// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"k6","header":"k7","description":"k8","cta":"k9"};